module.exports = __webpack_public_path__ + "static/media/sample.974a4322.png";